/* FormRendererUtilities.js */

var CONTROL_TYPE = require("../typedefinitions/formcontrol/FormControlType.enum");
module.exports = function (logger) {
    /**
     *
     * @param configSettingsProperty {ConfigurationSettingsProperty} The type information representing a form Control.
     * @returns {FormControlType} The FormControlType of this ConfigurationSettingsProperty
     */
    this.getFormControlTypeFromConfigSettings = function (configSettingsProperty) {
        var type = CONTROL_TYPE.UNKNOWN;
        if (configSettingsProperty) {
            //Map configSettings type to CONTROL_TYPE
            switch (configSettingsProperty.fieldType) {
                case "String":
                    type = CONTROL_TYPE.TEXT;
                    break;
                case "Number":
                    type = CONTROL_TYPE.NUMBER;
                    break;
                case "Object":
                    if (
                        _.get(configSettingsProperty, "Display.tab") &&
                        !_.get(configSettingsProperty, "Display.hidden")
                    ) {
                        type = CONTROL_TYPE.TAB_GROUP;
                    } else {
                        type = CONTROL_TYPE.OBJECT;
                    }
                    break;
                case "Tab":
                    if (_.isArray(configSettingsProperty.value)) {
                        if (_.has(configSettingsProperty, "Display.editor")) {
                            type = CONTROL_TYPE.TAB_OBJECT;
                        } else {
                            type = CONTROL_TYPE.TAB_ARRAY;
                        }
                    } else {
                        type = CONTROL_TYPE.TAB_OBJECT;
                    }
                    break;
                case "Boolean":
                    type = CONTROL_TYPE.BOOLEAN;
                    break;
                case "Array":
                    if (_.get(configSettingsProperty, "Display.tab")) {
                        type = CONTROL_TYPE.TAB_GROUP;
                    } else if (
                        _.has(configSettingsProperty, "Display.text") ||
                        _.has(configSettingsProperty, "Display.editor")
                    ) {
                        type = CONTROL_TYPE.TEXT;
                    } else {
                        type = CONTROL_TYPE.ARRAY;
                    }
                    break;
                case "Enum":
                    type = CONTROL_TYPE.ENUM;
                    break;
                case "Choice":
                    type = CONTROL_TYPE.CHOICE_OPTIONS;
                    break;
                case "Select":
                    type = CONTROL_TYPE.SELECT_OPTIONS;
                    break;
                case "Complete":
                    if (_.isObject(configSettingsProperty.options)) {
                        type = CONTROL_TYPE.COMPLETE_OPTIONS;
                    } else if (!_.isUndefined(configSettingsProperty.allType)) {
                        type = CONTROL_TYPE.COMPLETE_ALL_TYPE;
                    } else {
                        //this is an unknown prop
                        logger.warn(
                            {configSettings: configSettingsProperty},
                            "(FormRendererUtilities.getFormControlTypeFromConfigSettings) Cannot determine Control Adapter Type, @Complete.options, and @Complete.allType are the only supported @Complete at this time..."
                        );
                    }
                    break;
                case "Ref":
                    type = CONTROL_TYPE.REF;
                    break;
                case "TabGroup":
                    type = CONTROL_TYPE.TAB_GROUP;
                    break;
                case "Null":
                    type = CONTROL_TYPE.NULL;
                    break;
                case "Regex":
                    type = CONTROL_TYPE.REGEX;
                    break;
                default:
                    //this is an unknown prop
                    logger.warn(
                        {typeString: configSettingsProperty.fieldType},
                        "(FormRendererUtilities.getFormControlTypeFromConfigSettings) Cannot determine Control Adapter Type, unknown type."
                    );
                    break;
            }
        }
        return type;
    };
};
